import { get } from "@rails/request.js"

const ID_ATTRIBUTE = "data-latest-notification-id"

function notificationsDiv(){
  return document.getElementById("user-notifications-div");
}

function alertDiv() {
  return notificationsDiv().querySelector("div");
}

function closeButton() {
  return notificationsDiv().querySelector("button");
}

function notificationsIndexBody(){
  return document.getElementById("user-notifications-index-body")
}

export async function updateNotificationsDiv(innerHTML) {
  notificationsDiv().innerHTML = innerHTML
  initialize();

  if (notificationsIndexBody() != null){

    const url = notificationsIndexBody().getAttribute("index-rows-path")
    const response = await get(url);

    if (response.ok)
      notificationsIndexBody().innerHTML = await response.text;

  }
}

function updateIndexRows(html){
  notificationsIndexBody().innerHTML = html;
}

function dismissNotification(){
  const notificationId = parseInt(alertDiv().getAttribute(ID_ATTRIBUTE));
  window.app.userNotificationsChannel.dismissNotification(notificationId);  
}

export function initialize(){
  const button = closeButton();

  if (button != null)
    button.addEventListener("click", dismissNotification);
}

